export default __webpack_public_path__ + "static/media/slide2.ab7d9080.webp";